import React, { useState } from 'react';
import { ViewOptions } from './SearchPageWithMap';
import { Icons } from '../../components';

import { useSwipeable } from 'react-swipeable';
import classNames from 'classnames';
import css from './SearchPage.module.css';

function TabSwipeable(props) {
  const { listings, isMobileLayout, onChangeSearchView, currentView } = props;
  const [swipeAnimation, setSwipeAnimation] = useState(null);

  const handleSwipe = direction => {
    setSwipeAnimation(direction); // 'up' or 'down'

    // Reset animation class after animation duration
    setTimeout(() => setSwipeAnimation(null), 500); // match with CSS animation time

    onChangeSearchView(currentView === ViewOptions.LIST ? ViewOptions.MAP : ViewOptions.LIST);
  };

  const swipeHandlers = useSwipeable({
    onSwipedDown: () => handleSwipe('down'),
    onSwipedUp: () => handleSwipe('up'),
    preventDefaultTouchmoveEvent: true,
    preventScrollOnSwipe: true,
    trackTouch: true,
  });
  
  return (
    <div
      className={classNames(
        css.showHideMap,
        currentView === 'map' && isMobileLayout ? css.showList : null,
        swipeAnimation === 'up' ? css.swipeUp : '',
        swipeAnimation === 'down' ? css.swipeDown : ''
      )}
      onClick={() =>
        onChangeSearchView(currentView === ViewOptions.LIST ? ViewOptions.MAP : ViewOptions.LIST)
      }
    >
      {currentView === 'map' ? (
        <div className={css.listView} {...swipeHandlers}>
          <span>&nbsp;</span>
          <p>Over {listings?.length} listings </p>
        </div>
      ) : (
        <span className={css.icon}>
          Map <Icons name="map" />
        </span>
      )}
    </div>
  );
}

export default TabSwipeable;
